import Localization, { TrustedValue } from 'lib/localization';

export default {
    hero: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.hero.header.title');
        },
        lxSubtitle() {
            const text = Localization.get('badoo_homepage@page_section.hero.header.subtitle');

            return text.replace(/-/g, '&#8209;');
        },
        lxOr() {
            return Localization.get('badoo_homepage@page_section.hero.or');
        },
        lxSignupFieldLabel() {
            return Localization.get('badoo_homepage@page_section.hero.signup_field.label');
        },
        lxFooterText(params: { terms_url: string; privacy_url: string }) {
            return Localization.get('badoo_homepage@page_section.hero.footer.text', params);
        },
        lxSeparatorText() {
            return Localization.get('badoo_homepage@page_section.hero.separator_text');
        },
    },

    chat: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.chat.header.title');
        },
        lxBodyText() {
            return Localization.get('badoo_homepage@page_section.chat.body.text', {
                __EOL__: TrustedValue.for('<br/>'),
            });
        },
    },

    intention: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.intention.header.title');
        },
        lxBodyTextP1() {
            return Localization.get('badoo_homepage@page_section.intention.body.text.p1', {
                __EOL__: TrustedValue.for('<br/>'),
            });
        },
        lxBodyTextP2() {
            return Localization.get('badoo_homepage@page_section.intention.body.text.p2', {
                __EOL__: TrustedValue.for('<br/>'),
            });
        },
        lxBubbleTag1() {
            return Localization.get('badoo_homepage@page_section.intention.bubble_tag.first.label');
        },
        lxBubbleTag2() {
            return Localization.get(
                'badoo_homepage@page_section.intention.bubble_tag.second.label'
            );
        },
        lxBubbleTag3() {
            return Localization.get('badoo_homepage@page_section.intention.bubble_tag.third.label');
        },
        lxPictureTitle(name: string, age: number) {
            return Localization.get('badoo_homepage@page_section.intention.picture.title', {
                name,
                age,
            });
        },
    },

    stories: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.stories.header.title');
        },
        lxBodyStory1() {
            return Localization.get('badoo_homepage@page_section.stories.body.story1');
        },
        lxBodyStory2() {
            return Localization.get('badoo_homepage@page_section.stories.body.story2');
        },
        lxBodyStory3() {
            return Localization.get('badoo_homepage@page_section.stories.body.story3');
        },
        lxSuccessStoriesLink() {
            return Localization.get('badoo_homepage@page_section.stories.stories_link');
        },
    },

    safety: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.safety.header.title');
        },
        lxBodyTextP1() {
            return Localization.get('badoo_homepage@page_section.safety.body.text.p1');
        },
        lxBodyTextP2() {
            return Localization.get('badoo_homepage@page_section.safety.body.text.p2');
        },
        lxBodyTextSafetyCentreLink() {
            return Localization.get(
                'badoo_homepage@page_section.safety.body.text.safety_centre_link'
            );
        },
    },

    trust: {
        lxTitle() {
            return Localization.get('badoo_homepage@page_section.trust.header.title');
        },
        lxBodyText() {
            return Localization.get('badoo_homepage@page_section.trust.body.text');
        },
        lxAppleRatingLabel({ rating, delimiter }: { rating: TrustedValue; delimiter: string }) {
            const lexem = Localization.get('badoo_homepage@page_section.trust.apple.rating.label', {
                num: rating,
                __CUT__: delimiter,
            });

            return lexem.replace('__CUT__', delimiter);
        },
        lxAppleStoreLabel() {
            return Localization.get('badoo_homepage@page_section.trust.apple.store.label');
        },
        lxGoogleDownloadsLabel({ downloads }: { downloads: number }) {
            return Localization.get('badoo_homepage@page_section.trust.google.downloads.label', {
                num: downloads,
            });
        },
        lxGoogleDownloadsValue(downloads: number) {
            return Localization.get('badoo_homepage@page_section.trust.google.downloads.value', {
                num: downloads,
            });
        },
        lxGoogleStoreLabel() {
            return Localization.get('badoo_homepage@page_section.trust.google.store.label');
        },
    },
};
